import React, { memo, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import CustomDateRangePicker from "../../../DatePicker/CustomDateRangePicker";
import {
  Checkbox,
  Box,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormControl,
  FormControlLabel,
  InputLabel,
  NativeSelect,
  TextField,
  Stack,
  Button,
  Tooltip,
  IconButton,
  Backdrop,
  CircularProgress,
  Typography,
  TableSortLabel,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CommentIcon from "@mui/icons-material/Comment";
import CloseIcon from "@mui/icons-material/Close";
import PrintTwoToneIcon from "@mui/icons-material/PrintTwoTone";
import pdfImage from "../../../Assets/images/pdf.jfif";
import excelImage from "../../../Assets/images/excel.png";
import configServ from "../../../../services/config";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useDebounce from "../../../hooks/useDebounce";
import SearchBox from "../../../Search/SearchBox";
import LoaderNew from "../../../Loader/LoaderNew";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import DownloadGoodsReceivePdf from "../../../Download/DownloadGoodsReceivePdf";
import DownloadGoodsReceiveExcel from "../../../Download/DownloadGoodsReceiveExcel";
import GoodsReceiveOrientation from "./GoodsReceiveOrientation";
import { getGoodFromLabel, getPartyDisplayName, getPoOrChallanDisplay, enrichReceiptForExport, isCustomerGr } from '../../../../utility/goodsReceiveDisplay';
import { appServiceName } from "../../../../services/http";

const searchByLabels = {
  purchase_bill_no: "Purchase Bill No",
  purchase_order_no: "Purchase Order No",
  grn_no: "GRN No",
  location: "Received At",
  staff_name: "Received By",
  supplier_name: "Supplier Name",
  customer_name: "Customer Name",
  challan_no: "Challan No",
};

//FUNCTION
const GoodsReceiveTable = ({ handleEditData, isChanged, setIsChanged }) => {
  //#region code
  const { user_id, company_id, is_super, is_admin } =
    useSelector((state) => state.GlobalVariables);
  console.log("Redux company_id:", company_id);
  const rowsPerPageOptions = [20, 50, 100, 200];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[1]);
  const [goodsReceiveList, setGoodsReceiveList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchBy, setSearchBy] = useState("grn_no");
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [itemsLoading, setItemsLoading] = useState(false);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [goodsReceiveItems, setGoodsReceiveItems] = useState([]);
  const location = useLocation();
  const redirectVoucherNo = location.state;
  const [dateRange, setDateRange] = useState([null, null]);
  const [sessionYear, setSessionYear] = useState("2026-27");
  const [approvalFilter, setApprovalFilter] = useState("all");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("grn_no");
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [uploadRow, setUploadRow] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [remarkDialogOpen, setRemarkDialogOpen] = useState(false);
  const [remarkRow, setRemarkRow] = useState(null);
  const [remarkText, setRemarkText] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [printModal, setPrintModal] = useState({ open: false, row: null });
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    console.log("goodsReceiveList updated:", goodsReceiveList);
  }, [goodsReceiveList]);

  useEffect(() => {
    if (redirectVoucherNo) {
      setSearch(redirectVoucherNo);
      fetchGoodsReceiveList(redirectVoucherNo, 0);
    } else {
      setSearch("");
    }
  }, [redirectVoucherNo]);

  useEffect(() => {
    if (!redirectVoucherNo) {
      fetchGoodsReceiveList(null, 0);
    }
  }, [isChanged]);

  useEffect(() => {
    if (!redirectVoucherNo) {
      fetchGoodsReceiveList();
    }
  }, [page, rowsPerPage, dateRange, approvalFilter, sessionYear, order, orderBy]);

  useEffect(() => {
    if (!redirectVoucherNo) {
      if (page === 0) {
        fetchGoodsReceiveList();
      } else {
        setPage(0);
      }
    }
  }, [debounceSearch, dateRange, approvalFilter, sessionYear]);

  const fetchGoodsReceiveList = async (searchOverride = null, pageOverride = null) => {
    try {
      const dataToSend = {
        is_super: is_super,
        user_id: user_id,
        company_id: company_id,
        search_by: searchOverride !== null ? "receipt_no" : searchBy,
        search: searchOverride !== null ? searchOverride : (redirectVoucherNo || search),
        per_page: rowsPerPage,
        page: (pageOverride !== null ? pageOverride : page) + 1,
        from_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : null,
        to_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : null,
        approval_status: approvalFilter,
        session_year: sessionYear,
        sort_by: orderBy,
        order: order,
      };
      console.log("Data to send:", dataToSend);

      setLoading(true);
      const res = await configServ.getGoodsReceives(dataToSend);
      console.log("API Response:", res);
      console.log("Response data:", res.data);

      if (res.status === 200) {
        console.clear();
        const apiData = res.data || {};
        const list = Array.isArray(apiData.data)
          ? apiData.data
          : Array.isArray(apiData)
          ? apiData
          : [];
        const totalCount =
          typeof apiData.count === "number"
            ? apiData.count
            : typeof apiData.total === "number"
            ? apiData.total
            : typeof apiData.recordsTotal === "number"
            ? apiData.recordsTotal
            : typeof apiData.totalRecords === "number"
            ? apiData.totalRecords
            : list.length;

        console.log("Setting goodsReceiveList to:", list);
        console.log("Setting count to:", totalCount);
        setGoodsReceiveList(list);
        setCount(totalCount);
        console.log("Data successfully loaded:", list);
      } else {
        console.clear();
        setGoodsReceiveList([]);
        setCount(0);
        console.log("API returned status:", res.status, "Response:", res.data);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleToggleRow = async (id) => {
    if (expandedRowId === id) {
      setExpandedRowId(null);
      return;
    }

    try {
      setItemsLoading(true);
      const dataToSend = {
        company_id: company_id,
        receipt_id: id,
      };

      const res = await configServ.getGoodsReceiveItems(dataToSend);

      if (res.status === 200) {
        setGoodsReceiveItems(res.data || []);
      } else {
        setGoodsReceiveItems([]);
      }

      setExpandedRowId(id);
    } catch (e) {
      console.log(e);
      setGoodsReceiveItems([]);
      setExpandedRowId(id);
    } finally {
      setItemsLoading(false);
    }
  };

  const handleDeleteClick = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this goods receive record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const dataToSend = {
          company_id: company_id,
          id: id,
          user_id: user_id,
        };

        const res = await configServ.deleteGoodsReceive(dataToSend);

        if (res.status === 200) {
          Swal.fire("Deleted!", "Goods receive deleted successfully.", "success");
          setIsChanged(!isChanged);
        } else {
          Swal.fire("Error", "Error deleting goods receive", "error");
        }
      }
    } catch (e) {
      console.log(e);
      Swal.fire("Error", "An error occurred", "error");
    }
  };

  const handleSelectAllClick = (event) => {
    if (!is_admin) return;
    if (event.target.checked) {
      const selectableIds = (goodsReceiveList || [])
        .filter((row) => row.is_approved !== "YES")
        .map((row) => row.id);
      setSelectedRows(selectableIds);
    } else {
      setSelectedRows([]);
    }
  };

  const toggleSelectionById = (id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1),
      );
    }

    setSelectedRows(newSelected);
  };

  const handleRowClick = (event, id, rowIsApproved) => {
    if (!is_admin) return;

    // Prevent row selection when clicking on expand icon or action buttons
    if (event.target.closest("button") || event.target.closest("input[type='checkbox']")) {
      return;
    }

    if (rowIsApproved) return;
    toggleSelectionById(id);
  };

  const isSelected = (id) => selectedRows.indexOf(id) !== -1;

  const handleOpenUploadDialog = (row) => {
    setUploadRow(row);
    setUploadFile(null);
    setUploadDialogOpen(true);
  };

  const handleCloseUploadDialog = () => {
    setUploadDialogOpen(false);
    setUploadRow(null);
    setUploadFile(null);
  };

  const handleUploadFileChange = (event) => {
    setUploadFile(event.target.files?.[0] || null);
  };

  const handleUploadSubmit = async () => {
    if (!uploadRow || !uploadFile) return;

    try {
      setActionLoading(true);
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("goods_receipt_id", uploadRow.id);
      formData.append("user_id", user_id);
      formData.append("file", uploadFile);

      const res = await configServ.uploadGoodsReceiveDocument(formData);

      if (res.status === 200) {
        Swal.fire("Success!", "Document uploaded successfully.", "success");
        handleCloseUploadDialog();
        setIsChanged(!isChanged);
      } else {
        Swal.fire("Error", res.message || "Failed to upload document.", "error");
      }
    } catch (e) {
      console.log(e);
      Swal.fire("Error", "An error occurred while uploading the document.", "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleOpenRemarkDialog = (row) => {
    setRemarkRow(row);
    setRemarkText(row.check_text || "");
    setRemarkDialogOpen(true);
  };

  const handleCloseRemarkDialog = () => {
    setRemarkDialogOpen(false);
    setRemarkRow(null);
    setRemarkText("");
  };

  const handleSubmitRemark = async () => {
    if (!remarkRow) return;

    try {
      setActionLoading(true);
      const dataToSend = {
        company_id: company_id,
        goods_receipt_id: remarkRow.id,
        check_text: remarkText,
        user_id: user_id,
      };
      const res = await configServ.updateGoodsReceiveCheck(dataToSend);

      if (res.status === 200) {
        Swal.fire("Success!", "Remark saved successfully.", "success");
        handleCloseRemarkDialog();
        setIsChanged(!isChanged);
      } else {
        Swal.fire("Error", res.message || "Failed to save remark.", "error");
      }
    } catch (e) {
      console.log(e);
      Swal.fire("Error", "An error occurred while saving the remark.", "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleViewDocument = (row) => {
    if (!row?.document) {
      console.warn("No document found");
      Swal.fire("Error", "No document found for this record.", "error");
      return;
    }

    let url;
    let documentPath = row.document;

    console.log("Document path from database:", documentPath);

    if (documentPath.startsWith("http://") || documentPath.startsWith("https://")) {
      // Already a full URL
      url = documentPath;
    } else {
      // Remove 'public/' prefix if it exists (Laravel standard)
      if (documentPath.startsWith("public/")) {
        documentPath = documentPath.substring(7); // Remove 'public/' prefix
      }

      // Ensure the path starts with a slash
      if (!documentPath.startsWith("/")) {
        documentPath = "/" + documentPath;
      }

      // Use backend service URL from config (supports dev, staging, production)
      url = `${appServiceName}${documentPath}`;
    }

    console.log("Final URL:", url);

    // Try to access the file first to check if it exists
    fetch(url, { method: "HEAD" })
      .then((response) => {
        if (response.ok) {
          // File exists, open it
          window.open(url, "_blank", "noopener,noreferrer");
        } else {
          console.error("File not found:", response.status);
          Swal.fire("Error", `File not found (Status: ${response.status}). Please check if document was uploaded.`, "error");
        }
      })
      .catch((error) => {
        console.error("Error accessing file:", error);
        // Still try to open it, as CORS might block HEAD request
        window.open(url, "_blank", "noopener,noreferrer");
        // Swal.fire(
        //   "Info",
        //   "Opening document from backend server. If it doesn't load, the file may not be accessible.",
        //   "info"
        // );
      });
  };

  const getSelectableRowCount = () =>
    (goodsReceiveList || []).filter((row) => row.is_approved !== "YES").length;

  const selectableRowCount = getSelectableRowCount();

  const isAllSelected =
    selectableRowCount > 0 && selectedRows.length === selectableRowCount;

  const isIndeterminate =
    selectedRows.length > 0 && selectedRows.length < selectableRowCount;

  const handleApproveSelected = async () => {
    if (!selectedRows.length) return;

    const confirmation = await Swal.fire({
      title: "Confirm Approval",
      text: `Approve ${selectedRows.length} selected goods receive record(s)?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) return;

    try {
      const dataToSend = {
        company_id: company_id,
        user_id: user_id,
        goods_receipt_ids: selectedRows,
      };
      const res = await configServ.approveGoodsReceive(dataToSend);

      if (res.status === 200) {
        Swal.fire("Approved!", "Selected records have been approved.", "success");
        setSelectedRows([]);
        setIsChanged(!isChanged);
      } else {
        Swal.fire("Error", res.message || "Failed to approve selected records.", "error");
      }
    } catch (e) {
      console.log(e);
      Swal.fire("Error", "An error occurred while approving selected records.", "error");
    }
  };

  const buildExportReceipt = async (receipt, supplierData, includeItems = false) => {
    let enriched = enrichReceiptForExport(receipt, supplierData);

    if (
      isCustomerGr(enriched) &&
      (!enriched.customer_name || enriched.customer_name === "N/A") &&
      enriched.customer_id
    ) {
      try {
        const customerRes = await configServ.getCustomerById({
          company_id,
          customer_id: enriched.customer_id,
        });
        const customer = customerRes?.data || customerRes;
        enriched = {
          ...enriched,
          good_from: 2,
          customer_name:
            customer?.contact_name || customer?.fname || enriched.customer_name,
        };
      } catch (e) {
        console.error("Error fetching customer for print:", e);
      }
    }

    if (!includeItems) {
      return enriched;
    }
    const itemsRes = await configServ.getGoodsReceiveItems({
      company_id: company_id,
      receipt_id: receipt.id,
    });
    const receiptItems = itemsRes?.status === 200 ? itemsRes.data || [] : [];
    const items = receiptItems.map((item) => ({
      ...item,
      item_name: item.item_name || item.itemName || item.name || "N/A",
      item_code: item.item_code || item.itemCode || item.code || "N/A",
      hsn_code: item.hsn_code || item.hsncode || item.hsn || "N/A",
      unit: item.unit || item.uom || item.uom_name || "N/A",
    }));
    return { ...enriched, items };
  };

  const handleDownloadPdf = async () => {
    const supplierRes = await configServ.getSupplier({ company_id });
    const supplierData = Array.isArray(supplierRes) ? supplierRes : supplierRes.data || [];

    const downloadList = await Promise.all(
      goodsReceiveList.map((receipt) => buildExportReceipt(receipt, supplierData, true)),
    );

    DownloadGoodsReceivePdf(downloadList, "Company Name", null, setOpenBackdrop, true);
  };

  const handleDownloadExcel = async () => {
    const res = await configServ.getSupplier({ company_id });
    const supplierData = Array.isArray(res) ? res : res.data || [];

    const downloadList = goodsReceiveList.map((receipt) =>
      enrichReceiptForExport(receipt, supplierData),
    );
    DownloadGoodsReceiveExcel(downloadList, "Company Name", setOpenBackdrop);
  };

  const handleDownloadSinglePdf = async (row) => {
    const supplierDataRes = await configServ.getSupplier({ company_id });
    const supplierData = Array.isArray(supplierDataRes) ? supplierDataRes : supplierDataRes.data || [];
    const downloadRow = await buildExportReceipt(row, supplierData, true);
    DownloadGoodsReceivePdf([downloadRow], "Company Name", null, setOpenBackdrop, true);
  };

  const handleOpenPrintDialog = async (row) => {
    try {
      const supplierDataRes = await configServ.getSupplier({ company_id });
      const supplierData = Array.isArray(supplierDataRes) ? supplierDataRes : supplierDataRes.data || [];
      const printRow = await buildExportReceipt(row, supplierData, true);
      setPrintModal({ open: true, row: printRow });
    } catch (e) {
      console.log(e);
    }
  };

  const handleClosePrintModal = () => {
    setPrintModal({ open: false, row: null });
  };

  const handleClearSearch = () => {
    setSearch(null);
  };

  const handleClearDateRange = () => {
    setDateRange([null, null]);
  };

  const handleClearApprovalFilter = () => {
    setApprovalFilter("all");
  };

  return (
    <React.Fragment>
      <Box sx={{ backgroundColor: "white", p: 2, borderRadius: 2 }}>
        <Grid item xs={12} justifyContent={"flex-start"}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Good Receives: {count}
          </Typography>
        </Grid>
        <Grid container spacing={1} sx={{ mb: 2 }} alignItems="flex-end">
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel variant="standard">Search By</InputLabel>
              <NativeSelect
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                label="Search By"
              >
                <option value="purchase_bill_no">Purchase Bill No</option>
                <option value="purchase_order_no">Purchase Order No</option>
                <option value="grn_no">GRN No</option>
                <option value="supplier_name">Supplier Name</option>
                <option value="customer_name">Customer Name</option>
                <option value="challan_no">Challan No</option>
                <option value="location">Received At</option>
                <option value="staff_name">Received By</option>
              </NativeSelect>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <SearchBox
              searchValue={search}
              setSearch={setSearch}
              placeholder={`Search by ${searchByLabels[searchBy] || searchBy}`}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel variant="standard">Session Year</InputLabel>
              <NativeSelect
                value={sessionYear}
                onChange={(e) => setSessionYear(e.target.value)}
                label="Session Year"
              >
                <option value="2023-24">2023-24</option>
                <option value="2024-25">2024-25</option>
                <option value="2025-26">2025-26</option>
                <option value="2026-27">2026-27</option>
                <option value="2027-28">2027-28</option>
              </NativeSelect>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel variant="standard">Approval Status</InputLabel>
              <NativeSelect
                value={approvalFilter}
                onChange={(e) => setApprovalFilter(e.target.value)}
                label="Approval Status"
              >
                <option value="all">All</option>
                <option value="approved">Approved</option>
                <option value="not_approved">Not Approved</option>
              </NativeSelect>
            </FormControl>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={1}>
            <Tooltip title="Refresh">
              <IconButton
                onClick={() => fetchGoodsReceiveList()}
                sx={{ width: "100%", justifyContent: "center" }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Grid> */}

          <Grid item xs={6} sm={6} md={2}>
            <CustomDateRangePicker
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onDateChange={setDateRange}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Tooltip title="Download PDF">
                <IconButton
                  onClick={handleDownloadPdf}
                  color="error"
                  size="small"
                >
                  <img
                    src={pdfImage}
                    alt="pdf"
                    style={{ width: 24, height: 24 }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download Excel">
                <IconButton
                  onClick={handleDownloadExcel}
                  color="success"
                  size="small"
                >
                  <img
                    src={excelImage}
                    alt="excel"
                    style={{ width: 24, height: 24 }}
                  />
                </IconButton>
              </Tooltip>
              {is_admin && selectedRows.length > 0 && (
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={handleApproveSelected}
                  sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                >
                  Approve ({selectedRows.length})
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>

        {(search || dateRange[0] || dateRange[1] || approvalFilter !== "all") && (
          <Box sx={{ mb: 2, p: 2, backgroundColor: "#f0f8ff", borderRadius: 1, border: "1px solid #4CB5F5" }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#1565c0", mb: 1 }}>
              Active Filters:
            </Typography>
            <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap sx={{ '& > *': { minWidth: 0 } }}>
              {search && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, backgroundColor: "white", p: 0.75, px: 1, borderRadius: 0.5, border: "1px solid #4CB5F5" }}>
                  <Typography variant="caption">
                    <strong>Search:</strong> {searchByLabels[searchBy] || searchBy} = "{search}"
                  </Typography>
                  <IconButton size="small" sx={{ p: 0, ml: 0.5 }} onClick={handleClearSearch}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              )}
              {(dateRange[0] || dateRange[1]) && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, backgroundColor: "white", p: 0.75, px: 1, borderRadius: 0.5, border: "1px solid #4CB5F5" }}>
                  <Typography variant="caption">
                    <strong>Date:</strong> {dateRange[0] ? dayjs(dateRange[0]).format("DD/MM/YYYY") : "N/A"} to {dateRange[1] ? dayjs(dateRange[1]).format("DD/MM/YYYY") : "N/A"}
                  </Typography>
                  <IconButton size="small" sx={{ p: 0, ml: 0.5 }} onClick={handleClearDateRange}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              )}
              {approvalFilter !== "all" && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, backgroundColor: "white", p: 0.75, px: 1, borderRadius: 0.5, border: "1px solid #4CB5F5" }}>
                  <Typography variant="caption">
                    <strong>Status:</strong> {approvalFilter === "approved" ? "Approved" : "Not Approved"}
                  </Typography>
                  <IconButton size="small" sx={{ p: 0, ml: 0.5 }} onClick={handleClearApprovalFilter}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              )}
            </Stack>
          </Box>
        )}

        {!isMobileView ? (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="goods receive table">
              <TableHead sx={{ backgroundColor: "#4CB5F5", '& th': { color: '#fff' } }}>
                <TableRow>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }} sortDirection={orderBy === "receipt_no" ? order : false}>
                    <TableSortLabel
                      active={orderBy === "receipt_no"}
                      direction={orderBy === "receipt_no" ? order : "asc"}
                      onClick={() => handleRequestSort("receipt_no")}
                      sx={{ color: "white !important" }}
                    >
                      GRN No
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bold" }}>
                    Supplier / Customer
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bold" }} sortDirection={orderBy === "purchase_order_no" ? order : false}>
                    <TableSortLabel
                      active={orderBy === "purchase_order_no"}
                      direction={orderBy === "purchase_order_no" ? order : "asc"}
                      onClick={() => handleRequestSort("purchase_order_no")}
                      sx={{ color: "white !important" }}
                    >
                      PO No / Challan No
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bold" }} sortDirection={orderBy === "purchase_bill_no" ? order : false}>
                    <TableSortLabel
                      active={orderBy === "purchase_bill_no"}
                      direction={orderBy === "purchase_bill_no" ? order : "asc"}
                      onClick={() => handleRequestSort("purchase_bill_no")}
                      sx={{ color: "white !important" }}
                    >
                      Bill No
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bold" }} sortDirection={orderBy === "location" ? order : false}>
                    <TableSortLabel
                      active={orderBy === "location"}
                      direction={orderBy === "location" ? order : "asc"}
                      onClick={() => handleRequestSort("location")}
                      sx={{ color: "white !important" }}
                    >
                      Received At
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bold" }} sortDirection={orderBy === "staff_name" ? order : false}>
                    <TableSortLabel
                      active={orderBy === "staff_name"}
                      direction={orderBy === "staff_name" ? order : "asc"}
                      onClick={() => handleRequestSort("staff_name")}
                      sx={{ color: "white !important" }}
                    >
                      Received By
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bold" }} sortDirection={orderBy === "receipt_date" ? order : false}>
                    <TableSortLabel
                      active={orderBy === "receipt_date"}
                      direction={orderBy === "receipt_date" ? order : "asc"}
                      onClick={() => handleRequestSort("receipt_date")}
                      sx={{ color: "white !important" }}
                    >
                      Receipt Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    Approved
                    {is_admin ? (
                      <Checkbox
                        indeterminate={isIndeterminate}
                        checked={isAllSelected}
                        onChange={handleSelectAllClick}
                        size="small"
                      />
                    ) : null}
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 3 }}>
                      <LoaderNew />
                    </TableCell>
                  </TableRow>
                ) : goodsReceiveList?.length > 0 ? (
                  goodsReceiveList.map((row) => {
                    const isExpanded = expandedRowId === row.id;
                    return (
                      <React.Fragment key={row.id}>
                        <TableRow
                          hover
                          onClick={is_admin ? (event) => handleRowClick(event, row.id, row.is_approved === 'YES') : undefined}
                          sx={{
                            backgroundColor: is_admin && isSelected(row.id) ? 'rgba(25, 118, 210, 0.16)' : '#F1F9FE',
                            cursor: is_admin ? 'pointer' : 'default',
                          }}
                        >
                          <TableCell align="center">
                            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                              <IconButton
                                onClick={() => handleToggleRow(row.id)}
                                size="small"
                                sx={{
                                  transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                                  transition: "transform 0.2s",
                                }}
                              >
                                <ExpandMoreIcon />
                              </IconButton>
                            </Stack>
                          </TableCell>
                          <TableCell align="center">{row.grn_no || 'N/A'}</TableCell>
                          <TableCell align="left">{getPartyDisplayName(row)}</TableCell>
                          <TableCell align="left">{getPoOrChallanDisplay(row)}</TableCell>
                          <TableCell align="left">{row.purchase_bill_no || 'N/A'}</TableCell>
                          <TableCell align="left">
                            <Tooltip title={row.location_address || 'N/A'}>
                              <span style={{ display: 'inline-block', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {row.location_address ? (row.location_address.length > 15 ? `${row.location_address.slice(0, 15)}...` : row.location_address) : 'N/A'}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left">{row.staff_name || 'N/A'}</TableCell>
                          <TableCell align="left">{row.billing_date ? dayjs(row.billing_date).format('DD/MM/YYYY') : 'N/A'}</TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={row.is_approved === 'YES' || isSelected(row.id)}
                              onChange={() => toggleSelectionById(row.id)}
                              size="small"
                              disabled={!is_admin || row.is_approved === 'YES'}
                              sx={{
                                ...(row.is_approved === 'YES' && {
                                  '&.Mui-checked': {
                                    color: '#4caf50',
                                  },
                                  '& .MuiSvgIcon-root': {
                                    fill: '#4caf50',
                                  }
                                })
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title={row.is_approved === 'YES' ? 'Edit disabled for approved record' : 'Edit'}>
                              <span>
                                <IconButton
                                  onClick={() => handleEditData([row])}
                                  size="small"
                                  sx={{ color: row.is_approved === 'YES' ? 'grey.500' : 'green' }}
                                  disabled={row.is_approved === 'YES'}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title="Upload Document">
                              <span>
                                <IconButton
                                  onClick={() => handleOpenUploadDialog(row)}
                                  size="small"
                                  sx={{ color: row.is_approved === 'YES' ? 'grey.500' : 'blue' }}
                                  disabled={row.is_approved === 'YES'}
                                >
                                  <UploadFileIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            {is_admin ? (
                              <Tooltip title={row.check_text ? 'Remark Added' : 'Add Remark'}>
                                <IconButton
                                  onClick={() => handleOpenRemarkDialog(row)}
                                  size="small"
                                  sx={{ color: row.check_text ? 'green' : 'info.main' }}
                                >
                                  <CommentIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            ) : null}
                            <Tooltip title="Print">
                              <IconButton
                                onClick={() => handleOpenPrintDialog(row)}
                                size="small"
                                sx={{ color: 'error.main' }}
                              >
                                <PrintTwoToneIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={10} sx={{ p: 0, borderBottom: 'none' }}>
                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                              <Box sx={{ p: 2, bgcolor: '#f9f9f9' }}>
                                {itemsLoading && expandedRowId === row.id ? (
                                  <LoaderNew />
                                ) : goodsReceiveItems?.length > 0 ? (
                                  <Table size="small">
                                    <TableHead sx={{ backgroundColor: '#4CB5F5', '& th': { color: '#fff', fontWeight: 'bold' } }}>
                                      <TableRow>
                                        <TableCell>Item Code</TableCell>
                                        <TableCell>Item</TableCell>
                                        <TableCell>Ordered</TableCell>
                                        <TableCell>Received</TableCell>
                                        <TableCell>Returned</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {goodsReceiveItems.map((item) => (
                                        <TableRow key={item.id} sx={{ backgroundColor: '#F1F9FE' }}>
                                          <TableCell>{item.item_code || 'N/A'}</TableCell>
                                          <TableCell>{item.item_name || 'N/A'}</TableCell>
                                          <TableCell>{item.order_qty || 0}</TableCell>
                                          <TableCell>{item.received_qty || 0}</TableCell>
                                          <TableCell>{item.rejected_qty || 0}</TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                ) : (
                                  <Typography variant="body2">No item details available</Typography>
                                )}
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 3 }}>
                      <Typography variant="body2">No data found</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box>
            {loading ? (
              <Paper sx={{ p: 4, textAlign: 'center' }}>
                <LoaderNew />
              </Paper>
            ) : goodsReceiveList?.length > 0 ? (
              <Stack spacing={2}>
                {goodsReceiveList.map((row) => {
                  const isExpanded = expandedRowId === row.id;
                  return (
                    <Card key={row.id} variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, overflow: 'hidden' }}>
                      <CardContent sx={{ p: 2, backgroundColor: isSelected(row.id) ? 'rgba(25, 118, 210, 0.08)' : '#fff' }}>
                        <Stack spacing={1}>
                          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1D5FB1' }}>
                                GRN No: {row.grn_no || 'N/A'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                Good From: {getGoodFromLabel(row)}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                {Number(row.good_from) === 2 ? 'Customer' : 'Supplier'}: {getPartyDisplayName(row)}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                {Number(row.good_from) === 2 ? 'Challan No' : 'PO No'}: {getPoOrChallanDisplay(row)}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                Bill: {row.purchase_bill_no || 'N/A'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                Received At: {row.location_address || 'N/A'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                Received By: {row.staff_name || 'N/A'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                Receipt Date: {row.billing_date ? dayjs(row.billing_date).format('DD/MM/YYYY') : 'N/A'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                Status: <Typography component="span" sx={{ color: row.is_approved === 'YES' ? 'green' : 'warning.main', fontWeight: 700 }}>{row.is_approved === 'YES' ? 'Approved' : 'Pending'}</Typography>
                              </Typography>
                              <Divider sx={{ my: 1 }} />
                              {row.is_approved != 'YES' ? (
                              <Tooltip title={row.is_approved === 'YES' ? 'Approved GR Note' : 'Check For Approve'}>
                                <Checkbox
                                  checked={row.is_approved === 'YES' || isSelected(row.id)}
                                  onChange={() => toggleSelectionById(row.id)}
                                  size="small"
                                  disabled={!is_admin || row.is_approved === 'YES'}
                                  sx={{
                                    ...(row.is_approved === 'YES' && {
                                      '&.Mui-checked': {
                                        color: '#4caf50',
                                      },
                                      '& .MuiSvgIcon-root': {
                                        fill: '#4caf50',
                                      }
                                    })
                                  }}
                                />
                              </Tooltip>
                              ) : null}
                              <Tooltip title={row.is_approved === 'YES' ? 'Edit disabled for approved record' : 'Edit'}>
                                <span>
                                  <IconButton
                                    onClick={() => handleEditData([row])}
                                    size="small"
                                    sx={{ color: row.is_approved === 'YES' ? 'grey.500' : 'green', p: 0, width: 34, height: 34 }}
                                    disabled={row.is_approved === 'YES'}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Upload Document">
                                <span>
                                  <IconButton
                                    onClick={() => handleOpenUploadDialog(row)}
                                    size="small"
                                    sx={{ color: row.is_approved === 'YES' ? 'grey.500' : 'blue', p: 0, width: 34, height: 34 }}
                                    disabled={row.is_approved === 'YES'}
                                  >
                                    <UploadFileIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              {is_admin ? (
                                <Tooltip title={row.check_text ? 'Remark Added' : 'Add Remark'}>
                                  <IconButton
                                    onClick={() => handleOpenRemarkDialog(row)}
                                    size="small"
                                    sx={{ color: row.check_text ? 'green' : 'info.main', p: 0, width: 34, height: 34 }}
                                  >
                                    <CommentIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              ) : null}
                              <Tooltip title="Print">
                                <IconButton
                                  onClick={() => handleOpenPrintDialog(row)}
                                  size="small"
                                  sx={{ color: 'error.main', p: 0, width: 34, height: 34 }}
                                >
                                  <PrintTwoToneIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleToggleRow(row.id);
                                }}
                                size="small"
                                sx={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                              >
                                <ExpandMoreIcon />
                              </IconButton>
                            </Box>
                          </Stack>

                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <Box sx={{ mt: 2, p: 2, backgroundColor: '#F9FAFB', borderRadius: 2 }}>
                              {itemsLoading && expandedRowId === row.id ? (
                                <LoaderNew />
                              ) : goodsReceiveItems?.length > 0 ? (
                                <Stack spacing={1}>
                                  {goodsReceiveItems.map((item) => (
                                    <Box key={item.id} sx={{ p: 1, borderRadius: 2, bgcolor: '#fff', border: '1px solid #E0E0E0' }}>
                                      <Typography variant="body2" sx={{ fontWeight: 700 }}>{item.item_name || 'N/A'}</Typography>
                                      <Typography variant="caption" color="text.secondary">Code: {item.item_code || 'N/A'}</Typography>
                                      <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
                                        <Typography variant="caption">Ordered: {item.order_qty || 0}</Typography>
                                        <Typography variant="caption">Received: {item.received_qty || 0}</Typography>
                                        <Typography variant="caption">Returned: {item.rejected_qty || 0}</Typography>
                                      </Stack>
                                    </Box>
                                  ))}
                                </Stack>
                              ) : (
                                <Typography variant="body2">No item details available</Typography>
                              )}
                            </Box>
                          </Collapse>
                        </Stack>
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            ) : (
              <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2">No data found</Typography>
              </Paper>
            )}
          </Box>
        )}

        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Dialog open={uploadDialogOpen} onClose={handleCloseUploadDialog} fullWidth maxWidth="sm">
          <DialogTitle>Upload Document</DialogTitle>
          <DialogContent>
            {uploadRow?.document ? (
              <Box sx={{ mb: 2 }}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ mb: 1 }}
                  onClick={() => handleViewDocument(uploadRow)}
                  fullWidth
                >
                  View Existing Document
                </Button>
                <Typography variant="caption" display="block" sx={{ color: 'gray', mt: 1 }}>
                  Path: {uploadRow.document}
                </Typography>
              </Box>
            ) : null}
            <Box sx={{ mt: 1 }}>
              <Button variant="contained" component="label">
                Choose File
                <input
                  hidden
                  type="file"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  onChange={handleUploadFileChange}
                />
              </Button>
              {uploadFile ? (
                <Typography sx={{ ml: 2, display: 'inline-flex', alignItems: 'center' }}>
                  {uploadFile.name}
                </Typography>
              ) : null}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseUploadDialog}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleUploadSubmit}
              disabled={!uploadFile || actionLoading}
            >
              {actionLoading ? "Uploading..." : "Upload"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={remarkDialogOpen} onClose={handleCloseRemarkDialog} fullWidth maxWidth="sm">
          <DialogTitle>{remarkRow?.check_text ? "Edit Remark" : "Add Remark"}</DialogTitle>
          <DialogContent>
            <TextField
              multiline
              minRows={4}
              fullWidth
              label="Remark"
              value={remarkText}
              onChange={(e) => setRemarkText(e.target.value)}
              sx={{ mt: 1 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseRemarkDialog}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSubmitRemark}
              disabled={!remarkText.trim() || actionLoading}
            >
              {actionLoading ? "Saving..." : "Save"}
            </Button>
          </DialogActions>
        </Dialog>

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <GoodsReceiveOrientation
          open={printModal.open}
          onClose={handleClosePrintModal}
          data={printModal.row}
        />
      </Box>
    </React.Fragment>
  );
};

export default memo(GoodsReceiveTable);
